import { urlStoredFilter } from '../../../scripts/utils/urlStoredFilter';

export const AVAILABLE_TAGS = {
  ALL: '',
  PRODUCT: 'Product',
  INTEGRATIONS: 'Integrations',
  LIFESTYLE: 'Lifestyle',
  BUILDERS: 'Builders',
  MULTIFAMILY: 'Multifamily',
  PRO_INSTALLERS: 'Pro-Installers',
};

export const runNewsroomInit = (initTag = '') =>
  urlStoredFilter({
    initValue: initTag,
    dataKey: 'tags',
    isMultiple: true,
  });
